/* ==========================================================================
   Versandkostenfrei-Balken auf der Produktseite aktuell halten.

   Der Block in main-product.liquid rechnet beim Rendern selbst, ist also
   schon beim Seitenaufruf richtig. Diese Datei kuemmert sich nur um das
   Danach: legt jemand etwas in den Warenkorb, ohne die Seite neu zu
   laden, wandert der Balken mit.

   Vorher hat das freeShippMsg() in theme.js erledigt - allerdings, indem
   es fuer eine einzige Textzeile den kompletten Warenkorb-Drawer als
   Section nachgeladen hat (gut 20 KB). Seit der Drawer auf
   kz-cart-progress umgestellt ist, findet diese Funktion ihre Quelle
   ohnehin nicht mehr.
   ========================================================================== */
(function () {
  'use strict';

  var ziele = document.querySelectorAll('[data-kz-freeship]');
  if (!ziele.length) return;

  /* Das Geldformat nicht raten, sondern vom Shop vorgeben lassen: Liquid
     rendert "{{ 0 | money }}" ins data-geld, also z. B. "€0,00". Daraus
     lesen wir Dezimal- und Tausendertrennzeichen und die Position des
     Waehrungszeichens ab. So sieht der per JS gesetzte Betrag genauso aus
     wie der, den der Server geschrieben hat. */
  function geld(cent, muster) {
    var treffer = (muster || '').match(/[\d.,]+/);
    var zahl = (cent / 100).toFixed(2).split('.');
    if (!treffer) return zahl[0] + ',' + zahl[1];
    var probe = treffer[0];
    var dez = probe.indexOf(',') > -1 ? ',' : '.';
    var tausend = dez === ',' ? '.' : ',';
    var ganz = zahl[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausend);
    return muster.replace(probe, ganz + dez + zahl[1]);
  }

  function zeichnen(summe) {
    if (typeof summe !== 'number') return;
    for (var i = 0; i < ziele.length; i++) {
      var box = ziele[i];
      var schwelle = Number(box.getAttribute('data-schwelle')) || 0;
      if (!schwelle) continue;

      var rest = schwelle - summe;
      /* Abrunden, nicht runden: bei 28,90 von 29 EUR waeren das sonst
         100 % - ein voller Balken neben "Nur noch 0,10 EUR". Solange noch
         etwas fehlt, bleibt der Balken sichtbar unfertig. */
      var pct = Math.floor(summe * 100 / schwelle);
      if (rest > 0 && pct > 99) pct = 99;
      if (pct > 100) pct = 100;
      if (pct < 0) pct = 0;

      var txt = box.querySelector('[data-kz-freeship-text]');
      if (txt) {
        if (rest > 0) {
          var vorlage = box.getAttribute('data-msg') || '';
          txt.innerHTML = vorlage.replace('$', '<b class="freeShip">' + geld(rest, box.getAttribute('data-geld')) + '</b>');
        } else {
          txt.innerHTML = box.getAttribute('data-msg-done') || '';
        }
      }
      var bar = box.querySelector('[data-kz-freeship-bar]');
      if (bar) bar.style.width = pct + '%';
    }
  }

  /* Das aktuelle fetch festhalten - kz-gifts-auto.js hat es moeglicherweise
     schon ersetzt. Unsere eigene Abfrage geht an /cart.js und loest den
     Warenkorb-Filter unten nicht aus, also keine Schleife. */
  var echtesFetch = window.fetch.bind(window);

  function nachfragen() {
    echtesFetch('/cart.js', {
      headers: { 'Accept': 'application/json' }, cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { zeichnen(c.total_price); })
      .catch(function () {});
  }

  var cartPfad = /\/cart\/(add|change|update|clear)(\.js)?/;

  window.fetch = function () {
    var url = arguments[0];
    var pfad = typeof url === 'string' ? url : (url && url.url) || '';
    var p = echtesFetch.apply(this, arguments);
    if (cartPfad.test(pfad)) {
      p.then(function (r) {
        /* Die Antwort enthaelt den Warenkorb meist schon. Nur wenn nicht
           (z. B. /cart/add.js antwortet mit der Zeile), einmal nachfragen. */
        var kopie = null;
        try { kopie = r.clone(); } catch (e) {}
        if (!kopie) { nachfragen(); return; }
        kopie.json()
          .then(function (d) {
            if (d && typeof d.total_price === 'number') zeichnen(d.total_price);
            else nachfragen();
          })
          .catch(function () { nachfragen(); });
      }).catch(function () {});
    }
    return p;
  };

  var echtesOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    if (cartPfad.test(url || '')) {
      this.addEventListener('load', nachfragen);
    }
    return echtesOpen.apply(this, arguments);
  };
})();
